import axios from "axios";
import React, { useEffect, useState } from "react";
import './BadgeStore.css';
import { useNavigate } from "react-router-dom";
import {AlertModal} from "../components/AlertModal/AlertModal";

export default function BadgeStore() {
    const [badges, setBadges] = useState([]);
    const [file, setFile] = useState(null);
    const [badgeImages, setBadgeImages] = useState({}); // Store image data URLs
    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState("")
    const [color, setColor] = useState("")
    const REACT_APP_ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

    useEffect(() => {
        if (!token) {
            handleUnauthorized();
            return;
        }
        getBadges();
    }, []);

    const getBadges = async () => {
        try {
            const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/badge-store`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setBadges(response.data);
            // Fetch images for each badge
            fetchBadgeImages(response.data);
        } catch (e) {
            if (e.response?.status === 401) {
                handleUnauthorized();
            } else {
                setShowAlert(true)
                setColor("red")
                setMessage("Error fetching badges: " + e.message);
            }
        }
    };

    const fetchBadgeImages = async (badges) => {
        const imagePromises = badges.map(async (badge) => {
            try {
                const response = await axios.get(
                    `${REACT_APP_ADMIN_API_URL}/api/v1/badge-store/${badge.name}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                        responseType: "blob" // Get image as binary data
                    }
                );
                const imageUrl = URL.createObjectURL(response.data);
                return { name: badge.name, url: imageUrl };
            } catch (e) {
                console.error(`Failed to load image for ${badge.name}:`, e);
                return { name: badge.name, url: null };
            }
        });

        const images = await Promise.all(imagePromises);
        const imageMap = images.reduce((acc, { name, url }) => {
            acc[name] = url;
            return acc;
        }, {});
        setBadgeImages(imageMap);
    };

    const handleUpload = async () => {
        if (!file) return;

        const fileNameExists = badges.some((badge) =>
            badge.name.toLowerCase() === file.name.toLowerCase()
        );
        if (fileNameExists) {
            setShowAlert(true)
            setColor("red")
            setMessage("Already have that badge name");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            await axios.post(`${REACT_APP_ADMIN_API_URL}/api/v1/badge-store/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`
                }
            });
            setFile(null); // Clear file input
            setShowAlert(true)
            setColor("green")
            setMessage("Badge upload successful");
            getBadges(); // Refresh badges and images
        } catch (e) {
            if (e.response?.status === 401) {
                handleUnauthorized();
            } else {
                setShowAlert(true)
                setColor("red")
                setMessage("Upload failed: " + e.message);
            }
        }
    };

    // const handleDelete = async (id) => {
    //     try {
    //         await axios.delete(`http://backend-admin:8080/api/v1/badge-store/${id}`, {
    //             headers: { Authorization: `Bearer ${token}` }
    //         });
    //         getBadges();
    //     } catch (e) {
    //         if (e.response?.status === 401) {
    //             handleUnauthorized();
    //         } else {
    //             setMessage("Delete failed: " + e.message);
    //         }
    //     }
    // };

    const handleUnauthorized = () => {
        localStorage.removeItem("token");
        //console.log("Session expired. Please log in again.");
        navigate("/login");
    };

    return (
        <div className="container mt-5 badge-store-container">
            {showAlert && (
        <AlertModal
          message={message}
          color={color}
          onClose={() => {
            setShowAlert(false)
            setMessage("")
            setColor("")
          }}
        />
      )}
            <div className="main-card shadow-sm p-4 mb-4">
                <h1 className="text-center mb-4 text-white fw-bold">Upload New Badge</h1>
                <div className="d-flex justify-content-center gap-3">
                    <input
                        type="file"
                        accept="image/png"
                        onChange={(e) => setFile(e.target.files[0])}
                        className="form-control w-50 custom-file-input"
                    />
                    <button
                        onClick={handleUpload}
                        className="btn btn-upload"
                        disabled={!file}
                    >
                        Upload Badge
                    </button>
                </div>
            </div>

            <div className="row row-cols-1 row-cols-md-3 g-4">
                {badges.map((badge) => (
                    <div className="col" key={badge.id}>
                        <div className="card h-100 shadow-sm badge-card">
                            <div className="card-body text-center">
                                {badgeImages[badge.name] ? (
                                    <img
                                        src={badgeImages[badge.name]}
                                        alt={badge.name}
                                        className="img-fluid rounded-circle mb-3 badge-image"
                                    />
                                ) : (
                                    <p>Loading image...</p>
                                )}
                                <h5 className="card-title">{badge.name}</h5>
                                {/* Uncomment if you want delete functionality */}
                                {/* <button
                                    onClick={() => handleDelete(badge.id)}
                                    className="btn btn-danger btn-sm"
                                >
                                    Delete
                                </button> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}